import { render, staticRenderFns } from "./table-empresas.vue?vue&type=template&id=68c6678a&"
import script from "./table-empresas.vue?vue&type=script&lang=js&"
export * from "./table-empresas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports